// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3PHFL","actionsCol":"EnrolledClinics_actionsCol__32KOJ"};